export default __webpack_public_path__ + "static/media/img_banner_benefit.2514d169.png";